import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Timestamp } from '../../../timestamp/Timestamp';

@Injectable({
  providedIn: 'root'
})
export class SupportEmailService {
  private readonly SUPPORT_EMAIL = 'fe_ci_semanticapiservice@bcn.bosch.com';
  
  constructor(private oauthService: OAuthService) {}

  /**
   * Generates a mailto link with pre-filled support request template
   * @param includeBrowserInfo - Whether to include browser user agent information
   * @returns mailto URL string
   */
  getEmailTemplate(includeBrowserInfo: boolean = false): string {
    // Get the current date in YYYY-MM-DD format
    const currentDate = new Date().toISOString().split('T')[0];
    
    // Get the username from OAuth claims or use a default value
    const username = this.oauthService.getIdentityClaims()?.['preferred_username'] || '<username>';
    
    // Get the compiled version and timestamp from Timestamp
    const version = Timestamp.version || '<release version>';
    const compiledTimestamp = Timestamp.stamp || '<compilation date>';
    
    // Build the email body with optional browser info
    let bodyContent = 
      `=== TICKET INFORMATION ===\n` +
      `Keyword: URL Shortener\n` +
      `User: ${username}\n` +
      `Version: ${version}\n` +
      `Compiled: ${compiledTimestamp}\n` +
      `Date: ${currentDate}\n` +
      `Support Group: Holistic Product Lifecycle Management\n` +
      `\n` +
      `=== IMPORTANT NOTE ===\n` +
      `If your issue is urgent, please call the hotline directly after sending this email.\n` +
      `You can then force the creation of the ticket and raise the priority if needed.\n` +
      `\n` +
      `=== PROBLEM DESCRIPTION ===\n` +
      `To resolve your request as quickly and effectively as possible,\n` +
      `please explain your issue in detail below:\n` +
      `\n` +
      `Problem:\n` +
      `\n` +
      `\n` +
      `Expected solution:\n` +
      `\n` +
      `\n`;

    // Add browser info if requested (typically for home component)
    if (includeBrowserInfo) {
      bodyContent += 
        `=== ADDITIONAL INFORMATION ===\n` +
        `Browser: ${navigator.userAgent}\n`;
    }
    
    // Create the email template
    const emailSubject = encodeURIComponent('Bosch URL Shortener Support Request');
    const emailBody = encodeURIComponent(bodyContent);
    
    return `mailto:${this.SUPPORT_EMAIL}?subject=${emailSubject}&body=${emailBody}`;
  }
}
